var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlarmRemind(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 2.5L1.66675 5M18.3334 5L15.8334 2.5M5.00008 15.8333L3.33341 17.5M15.0001 15.8333L16.6667 17.5M10.0001 7.5V10.8333L11.6667 12.5M10.0001 17.5C11.7682 17.5 13.4639 16.7976 14.7141 15.5474C15.9644 14.2971 16.6667 12.6014 16.6667 10.8333C16.6667 9.06522 15.9644 7.36953 14.7141 6.11929C13.4639 4.86905 11.7682 4.16667 10.0001 4.16667C8.23197 4.16667 6.53628 4.86905 5.28604 6.11929C4.03579 7.36953 3.33341 9.06522 3.33341 10.8333C3.33341 12.6014 4.03579 14.2971 5.28604 15.5474C6.53628 16.7976 8.23197 17.5 10.0001 17.5Z",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmRemind);
export default __webpack_public_path__ + "static/media/AlarmRemind.5a3bac5e5d85767becb70e813acb87b8.svg";
export { ForwardRef as ReactComponent };